import React from 'react'
import OmowienieZasad from './OmowienieZasad'
import MetodyWyceny from './MetodyWyceny'
import UstalenieWynikuFinansowego from './UstalenieWynikuFinansowego'
import UstalenieSposobuSporzadzenia from './UstalenieSposobuSporzadzenia'

export default function PolitykaRachunkowosci(props) {
  return (
    <>
      <OmowienieZasad
        data={props.data}
        errors={props.errors}
        onSetSectionData={props.onSetSectionData}
        czyPodsumowanie={props.czyPodsumowanie}
      />
      <MetodyWyceny
        data={props.data}
        errors={props.errors}
        onSetSectionData={props.onSetSectionData}
        czyPodsumowanie={props.czyPodsumowanie}
      />
      <UstalenieWynikuFinansowego
        data={props.data}
        errors={props.errors}
        onSetSectionData={props.onSetSectionData}
        czyPodsumowanie={props.czyPodsumowanie}
      />
      <UstalenieSposobuSporzadzenia
        data={props.data}
        errors={props.errors}
        onSetSectionData={props.onSetSectionData}
        czyPodsumowanie={props.czyPodsumowanie}
      />
    </>
  )
}
